import {useEffect, useState} from "react"


const Date = (props) => {
    const {name, value, size, label, className, error, required, suffix, isReady, ...rest} = props
    const [inputValue, setInputValue] = useState('')


    const handleChange = (ev) => {
        ev.preventDefault()
        setInputValue(ev.target.value)
    }


    useEffect(() => {
        setInputValue(value ?? '')
    }, [value])


    return (
        <div className={`form-group${className ? ' '+className : ''}`}>
            {label && <label>
                {required && <span className="text-red required">* </span>}
                {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <input
                    type="datetime-local"
                    name={name}
                    value={inputValue}
                    disabled={!isReady}
                    onChange={handleChange}
                    className={`form-control ${!isReady ? 'is-loading' : ''} form-control-${size ? size : 'sm'} ${className ? className : ''}`}
                    {...rest}
                />

                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Date